import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
	selector: '[appSetTextColorToFitBackgroundContrast]',
})
export class SetTextColorToFitBackgroundContrastDirective implements OnChanges {
	@Input('appSetTextColorToFitBackgroundContrast') bgColor: string;

	constructor(private element: ElementRef) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['bgColor']) {
			this.updateTextColor();
		}
	}

	private updateTextColor(): void {
		const el: HTMLElement = this.element.nativeElement;
		el.style.color = 'black';

		let bgColor = this.bgColor;

		if (!bgColor) return;

		if (!bgColor.includes('rgb')) {
			bgColor = this.namedToRGB(bgColor);
		}

		if (bgColor === 'rgba(0, 0, 0, 0)') return;

		const colorComponents = bgColor.match(/\d+/g);
		if (!colorComponents || colorComponents.length < 3) return;

		const [red, green, blue] = colorComponents.map(Number);

		const brightness = (red * 299 + green * 587 + blue * 114) / 1000;

		const color = brightness > 125 ? 'black' : 'white';

		el.style.color = color;
	}

	private namedToRGB(colorName: string): string {
		const fakeDiv = document.createElement('div');
		fakeDiv.style.color = colorName;
		document.body.appendChild(fakeDiv);

		const computedColor = window.getComputedStyle(fakeDiv).color;

		document.body.removeChild(fakeDiv);
		return computedColor;
	}
}
